export default __webpack_public_path__ + "static/section_9_details_2-cd575ef19ee916d13e973245caf7def0.png";